webpackJsonp([221662759943617],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/contact-us/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _section, _section2, _column, _column2, _column2column;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactUs = function (_React$Component) {
	  _inherits(ContactUs, _React$Component);
	
	  function ContactUs() {
	    _classCallCheck(this, ContactUs);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ContactUs.prototype.render = function render() {
	
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(
	        _reactHelmet.Helmet,
	        { title: 'Contact Us' },
	        Glamor.createElement('meta', { name: 'description', content: 'Talk to the team about how CarePlanner can work for you.' }),
	        Glamor.createElement('meta', { property: 'og:type', content: 'website' }),
	        Glamor.createElement('meta', { property: 'og:title', content: 'Contact CarePlanner' }),
	        Glamor.createElement('meta', { property: 'og:description', content: 'Talk to the team about how CarePlanner can work for you.' }),
	        Glamor.createElement('meta', { name: 'twitter:title', content: 'Contact CarePlanner' }),
	        Glamor.createElement('meta', { name: 'twitter:description', content: 'Talk to the team about how CarePlanner can work for you.' })
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section1 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'h1',
	            null,
	            'Contact Us'
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section2 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'div',
	            { css: styles.column1 },
	            Glamor.createElement('iframe', { id: '62022480953351', style: { border: 0 } }),
	            Glamor.createElement('script', { src: 'https://form.jotformeu.com/jsform/62022480953351' })
	          ),
	          Glamor.createElement(
	            'div',
	            { css: styles.column2 },
	            Glamor.createElement(
	              'h2',
	              null,
	              'Office'
	            ),
	            Glamor.createElement(
	              'div',
	              { css: styles.column2column },
	              Glamor.createElement(
	                'p',
	                null,
	                'CarePlanner',
	                Glamor.createElement('br', null),
	                '11th Floor',
	                Glamor.createElement('br', null),
	                'Colston Tower',
	                Glamor.createElement('br', null),
	                'Bristol',
	                Glamor.createElement('br', null),
	                'BS1 4XE'
	              )
	            ),
	            Glamor.createElement(
	              'h2',
	              null,
	              'Sales Enquiries'
	            ),
	            Glamor.createElement(
	              'p',
	              null,
	              Glamor.createElement(
	                'b',
	                null,
	                'Email: '
	              ),
	              Glamor.createElement(
	                'a',
	                { href: 'mailto:enquiries@care-planner.co.uk' },
	                'enquiries@care-planner.co.uk'
	              )
	            ),
	            Glamor.createElement(
	              'p',
	              null,
	              Glamor.createElement(
	                'b',
	                null,
	                'Phone: '
	              ),
	              Glamor.createElement(
	                'span',
	                null,
	                '+44 (0) 117 214 0125'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ContactUs;
	}(_react2.default.Component);
	
	exports.default = ContactUs;
	;
	
	var styles = {
	  section1: (_section = {
	    background: '#F4F8FC'
	  }, _section[_presets2.default.Desktop] = {
	    padding: '100px'
	  }, _section[_presets2.default.Tablet] = {
	    padding: '100px'
	  }, _section[_presets2.default.Mobile] = {
	    padding: '70px 50px'
	
	  }, _section),
	  section2: (_section2 = {}, _section2[_presets2.default.Desktop] = {
	    width: 'calc(100% - 200px)',
	    padding: '50px 100px 100px 100px'
	  }, _section2[_presets2.default.Tablet] = {
	    width: 'calc(100% - 100px)',
	    padding: '50px 50px'
	  }, _section2[_presets2.default.Mobile] = {
	    width: 'calc(100% - 40px)',
	    padding: '0px 20px'
	  }, _section2),
	  column1: (_column = {}, _column[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '40%',
	    width: '40%',
	    margin: '0 1%',
	    height: '694px'
	  }, _column[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '50%',
	    width: '50%',
	    margin: '0 1%'
	  }, _column[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _column),
	  column2: (_column2 = {}, _column2[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '48%',
	    width: '48%',
	    margin: '0 5%'
	  }, _column2[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '38%',
	    width: '38%',
	    margin: '0 5%'
	  }, _column2[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _column2),
	  column2column: (_column2column = {}, _column2column[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '50%',
	    width: '50%'
	  }, _column2column[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '100%',
	    width: '100%'
	  }, _column2column[_presets2.default.Mobile] = {
	    maxWidth: '100%',
	    width: '100%'
	  }, _column2column)
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-us-index-js-66b7918401693f3697ea.js